<template>
  <v-content class="full-height">
    <v-container fluid grid-list-md class="listar">
      <h2>Selecione o Extrato a Pesquisar</h2>
      <nav class="box-buttons">
        <router-link
          v-for="(item, index) in items"
          :key="index"
          class="buttons-options"
          :to="{ path: item.routeName }"
        >
          <button class="button jns-button yellow-button">
            <v-icon class="icon-button">{{ item.icon }}</v-icon>
            {{ item.text }}
          </button>
        </router-link>
      </nav>
    </v-container>
  </v-content>
</template>

<script>
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "OpçõesExtratosListar",
  mixins: [ViewMixin],
  data: () => ({
    items: [
      {
        text: "Extrato de Comissão",
        icon: "description",
        routeName: "Recibos",
      },
      {
        text: "Extrato de Produção",
        icon: "description",
        routeName: "Extratos",
      },
    ],
  }),
};
</script>

<style lang="scss" scoped>
#jns {
  $blue-color: #061d45;
  $white-color: #fff;

  .listar {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h2 {
      padding: 6.25rem 0 2.5rem 0;
      color: $blue-color;
    }

    .box-buttons {
      display: flex;
      width: 100%;
      justify-content: space-around;
      align-items: center;

      .buttons-options {
        width: 40%;

        .icon-button {
          color: $blue-color;
        }
      }
    }

    .box-buttons {
      .buttons-options:hover {
        .icon-button {
          color: $white-color;
        }
      }
    }

    @media screen and (max-width: 860px) {
      .box-buttons {
        justify-content: center;
        flex-direction: column;

        .buttons-options {
          width: 100%;
          margin-bottom: 2rem;
        }
      }
    }

    @media screen and (max-width: 595px) {
      .box-buttons {
        .buttons-options {
          .jns-button {
            font-size: 1rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/ExtratosRecibos/Listar.vue